module.exports = [{"ruleKey":"A","colour":"#ffffff","operation":"root","successors":{"kind":"all","rule":"B"},"scale":0.58},{"ruleKey":"B","colour":"#ff5900","successors":{"kind":"specific","rules":["C",null,null,null,null,null]},"operation":"bigPop","scale":0.58},{"ruleKey":"C","colour":"#ffffff","successors":{"kind":"all","rule":"B"},"operation":"pyramid","scale":1}]


//////////////////
// WEBPACK FOOTER
// ./src/data/examples/floral.json
// module id = 104
// module chunks = 35783957827783 213497200229540